import { FileQuestion, Home, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "wouter";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 brushed-steel vignette-deep">
      <Card className="max-w-md w-full machined-edge bg-pro-gunmetal/80 border-pro-gunmetal">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-pro-clay/20 rounded-full flex items-center justify-center mb-4 border border-pro-clay/30">
            <FileQuestion className="w-8 h-8 text-pro-clay" />
          </div>
          <CardTitle className="text-2xl text-white font-broadcast">PAGE NOT FOUND</CardTitle>
          <CardDescription className="text-base mt-2 text-white/70">
            The page you're looking for doesn't exist or has been moved.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-sm text-white/60">
          <p>Double-check the URL or head back to explore our tournament management tools.</p>
        </CardContent>
        <CardFooter className="flex gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            data-testid="button-go-back"
            className="border-pro-gunmetal text-white hover:bg-pro-gunmetal"
          >
            Go Back
          </Button>
          <Link href="/">
            <Button data-testid="button-go-home" className="bg-pro-field hover:bg-pro-field/90">
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
}
